<p [innerHTML]="'responsible-gaming.covid-message' | translate"></p>

<button mat-flat-button color="accent" test-id="start-playing" (click)="closeDialog()">
	{{ 'general.start-playing' | translate }}
</button>

<a test-id="responsible-gaming-link" [obgRouteLink]="routeName" (click)="goToResponsibleGaming()"
	>{{ 'responsible-gaming.settings' | translate }}
</a>
